import { useRef } from "react";
import { Popper, Box, Fade } from "@mui/material";
import Chat from "../Chat";
import SocketProvider from "../../../contexts/SocketContext";
import { useChatWindowSettings } from "../../../contexts/ChatWindowContext";
import ChatFab from "../ChatFab";
import {
  DEFAULT_WIDGET_WIDTH,
  DEFAULT_WIDGET_HEIGHT,
} from "../../../constants";

function ChatWrapper() {
  const chatFab = useRef(null);
  const { open, isReady, toggleWindow, iframeSizes, isMobile } =
    useChatWindowSettings();

  return (
    <Box
      data-iframe-height
      data-iframe-width
      sx={{
        position: "relative",
        height: open ? iframeSizes.height + 20 : "100px",
        width: open ? iframeSizes.width + 20 : "100px",
      }}
    >
      <ChatFab chatFabRef={chatFab} />
      {isReady && (
        <SocketProvider>
          <Box>
            {chatFab.current && (
              <Popper
                open={open}
                anchorEl={isMobile ? null : chatFab.current}
                placement="top-start"
                disablePortal
                transition={true}
                sx={{
                  zIndex: 1001,
                }}
                modifiers={[
                  {
                    name: "offset",
                    options: {
                      offset: [0, 10],
                    },
                  },
                ]}
              >
                {({ TransitionProps }) => (
                  <Fade
                    {...TransitionProps}
                    timeout={350}
                    unmountOnExit
                    addEndListener={() => open && toggleWindow(true)}
                    onExited={() =>
                      // eslint-disable-next-line no-restricted-globals
                      toggleWindow(false)
                    }
                  >
                    <Box
                      sx={{
                        width: isMobile
                          ? iframeSizes.width
                          : DEFAULT_WIDGET_WIDTH,
                        height: isMobile
                          ? iframeSizes.height
                          : DEFAULT_WIDGET_HEIGHT,
                      }}
                      id="chatbotContainer"
                    >
                      <Chat />
                    </Box>
                  </Fade>
                )}
              </Popper>
            )}
          </Box>
        </SocketProvider>
      )}
    </Box>
  );
}

export default ChatWrapper;
